import {FC} from 'react';
import clsx from 'clsx';

import EngineSwitch from '~/app-header/components/EngineSwitch/EngineSwitch';
import ManageMenu from '~/app-header/components/ManageMenu';
import MainLogo from '~/app-header/components/MainLogo';
import SearchForm from '~/app-header/components/HeaderMenu/parts/SearchForm';
import HeaderMenu from '~/app-header/components/HeaderMenu';

import s from '../../styles.module.scss';

interface DesktopSearchHeaderProps {
  manageMenu: any;
  impersonate: any;
  mail: any;
  form: any;
  onSubmit: any;
  searchForm: any;
  isWorker: boolean;
}

const DesktopSearchHeader: FC<DesktopSearchHeaderProps> = ({
  manageMenu,
  form,
  onSubmit,
  searchForm,
  impersonate,
  mail,
  isWorker,
}) => {
  const handleEngineChange = () => {
    form.handleSubmit(onSubmit)();
  };

  return (
    <div className={clsx(s['header-root'], s['search-header'])}>
      <MainLogo variant="small" />
      <div className={s['search-header__search-bar']}>
        <SearchForm
          form={form}
          onSubmit={onSubmit}
          photoSearch={searchForm.searchByPhoto}
          photoSearchBlob={searchForm.searchByPhotoBlob}
        />
        {isWorker && <EngineSwitch onChange={handleEngineChange} />}
        {manageMenu.visible && <ManageMenu content={manageMenu.content} />}
      </div>
      <HeaderMenu
        impersonate={impersonate}
        mail={mail}
        notifyButtonClassName={s['notify-button']}
      />
    </div>
  );
};

export default DesktopSearchHeader;
